export enum SalaryMode {
  Monthly,
  Hourly
}

export namespace SalaryMode {
  export function getSalaryModes() {
    this.salaryModes = [];
    for (const n in SalaryMode) {
      if (!isNaN(Number.parseInt(n))) {
        this.salaryModes.push(Number.parseInt(n));
      }
    }
    return this.salaryModes;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/enums/salary-mode.enum.ts